import React, { useState } from 'react';

function SurveyStepTwentySeven({ formData, onNext }) {
    const [comfortDiscussingWellbeing, setComfortDiscussingWellbeing] = useState(formData.comfortDiscussingWellbeing || '');
    const [wellbeingComments, setWellbeingComments] = useState(formData.wellbeingComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!comfortDiscussingWellbeing) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ comfortDiscussingWellbeing, wellbeingComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 6: Employee Well-being</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How comfortable do you feel to discuss well-being challenges with your manager? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`comfort-discussing-${option}`}
                            name="comfortDiscussingWellbeing"
                            value={option}
                            checked={comfortDiscussingWellbeing === option}
                            onChange={() => setComfortDiscussingWellbeing(option)}
                        />
                        <label htmlFor={`comfort-discussing-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={wellbeingComments}
                    onChange={(e) => setWellbeingComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!comfortDiscussingWellbeing}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentySeven;
